import { render, staticRenderFns } from "./MobileBottomMenuItem.vue?vue&type=template&id=0dba9028&"
import script from "./MobileBottomMenuItem.vue?vue&type=script&lang=ts&"
export * from "./MobileBottomMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports